import {Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {roundTo} from '../../../helpers'
import {useKilnConfig} from '../../../providers'
import {KilnConfigActionType} from '../../../types'
import {KilnConfigTextField} from '../common'

export const OverallKilnConfigInputs: React.FC = () => {
  const {t} = useTranslation()
  const {kilnConfiguration, dispatch} = useKilnConfig()

  return (
    <Stack direction="row" spacing={1.5}>
      <KilnConfigTextField
        label={t('kilnConfig.kilnName')}
        value={kilnConfiguration.name}
        data-test-id="kiln-name-input"
        onChange={(e) =>
          dispatch({type: KilnConfigActionType.SET_KILN_NAME, payload: e.target.value})
        }
      />
      <KilnConfigTextField
        label={t('kilnConfig.kilnLength')}
        type="number"
        value={roundTo(Number(kilnConfiguration.dimensions.length))}
        inputProps={{min: 0}}
        data-test-id="kiln-length-input"
        onChange={(e) =>
          dispatch({type: KilnConfigActionType.SET_KILN_LENGTH, payload: Number(e.target.value)})
        }
      />
      <KilnConfigTextField
        label={t('kilnConfig.kilnDiameter')}
        type="number"
        value={roundTo(Number(kilnConfiguration.dimensions.diameter))}
        inputProps={{min: 0}}
        data-test-id="kiln-diameter-input"
        onChange={(e) =>
          dispatch({type: KilnConfigActionType.SET_KILN_DIAMETER, payload: Number(e.target.value)})
        }
      />
    </Stack>
  )
}
